import ActiveProfile from './ActiveProfile'
import unescape from 'lodash/unescape'
import { USER_TYPE_CUSTOMER_COMPANY } from '@/constants/user/roles'
import Skill from '@/models-ts/Skill'

export default class CompanyProfile extends ActiveProfile {
  type: typeof USER_TYPE_CUSTOMER_COMPANY
  company_name: string | null
  company_size: number | null
  registered: number | null
  description: string | null
  website: string | null
  address: string | null
  relations: {
    Country: Array<{ id: number; name: string }> | null
    Skill: Array<Skill> | null
    Currency: Array<{ id: number; name: string }> | null
  }

  constructor(data: Partial<CompanyProfile>) {
    super(data as LX.ActiveProfile)
    Object.assign(this, {
      type: data.type,
      company_name: data.company_name,
      company_size: data.company_size,
      registered: data.registered,
      description: data.description,
      website: data.website,
      address: data.address,
      relations: {
        Country: data.relations?.Country || [],
        Skill: data.relations?.Skill || [],
        Currency: data.relations?.Currency || [],
      },
    })
  }

  static fromServer(data: LX.CompanyProfile) {
    const name = unescape(data.company_name || '')
    return new CompanyProfile({
      type: USER_TYPE_CUSTOMER_COMPANY,
      company_name: name,
      company_size: data.company_size || null,
      registered: data.registered || null,
      description: data.description || '',
      website: data.website || '',
      address: data.address || '',
      relations: {
        Country: data.relations?.Country || [],
        Skill: (data.relations?.Skill || []).map(Skill.fromServer),
        Currency: data.relations?.Currency || [],
      },
      first_name: data.first_name,
      last_name: data.last_name,
      id: data.id || data.user_id,
    })
  }

  get name() {
    return unescape(this.company_name || '')
  }
}
